export default __webpack_public_path__ + "static/2.1-61cdc255efabda1e8f4d2a7ed67242c9.webp";